import * as MENUS from './Menus'

export default {
    MENUS
}
